import {
  defaultSystemCode,
  defaultTrader,
  exists,
  SystemCode,
  SystemCodeFromJSON,
  Trader,
  TraderFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface BibliographyRealDetailCollection {
  id: number
  collectionNo: string
  holdingBranchCode: SystemCode
  callNo: string
  shelfType: SystemCode
  collectionType: SystemCode
  status: SystemCode
  handlingType: SystemCode
  appendixCode: SystemCode
  dueDate: string
  processedDate: string
  processedBranchCode: SystemCode
  forwardingBranchCode: SystemCode
  userId: string
  workMemo: string
  displayMemo: string
  localMemo: string
  appendixLendFlag: boolean
  revision: number
  childCollectionCount: number
  traderCode: Trader
  acceptType: SystemCode
  orderPrice: number
}

export function BibliographyRealDetailCollectionFromJSON(
  json: any
): BibliographyRealDetailCollection {
  return {
    id: json.id,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    holdingBranchCode: exists(json, 'holding_branch_code')
      ? SystemCodeFromJSON(json.holding_branch_code)
      : defaultSystemCode(),
    callNo: json.call_no,
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    status: exists(json, 'status')
      ? SystemCodeFromJSON(json.status)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    appendixCode: exists(json, 'appendix_code')
      ? SystemCodeFromJSON(json.appendix_code)
      : defaultSystemCode(),
    dueDate: exists(json, 'due_date') ? dateToPlainFormat(json.due_date) : '',
    processedDate: exists(json, 'processed_date')
      ? dateToPlainFormat(json.processed_date)
      : '',
    processedBranchCode: exists(json, 'processed_branch_code')
      ? SystemCodeFromJSON(json.processed_branch_code)
      : defaultSystemCode(),
    forwardingBranchCode: exists(json, 'forwarding_branch_code')
      ? SystemCodeFromJSON(json.forwarding_branch_code)
      : defaultSystemCode(),
    userId: exists(json, 'user_id') ? json.user_id : '',
    workMemo: exists(json, 'work_memo') ? json.work_memo : '',
    displayMemo: exists(json, 'display_memo') ? json.display_memo : '',
    localMemo: exists(json, 'local_memo') ? json.local_memo : '',
    appendixLendFlag: exists(json, 'appendix_lend_flag')
      ? json.appendix_lend_flag
      : false,
    revision: json.revision,
    childCollectionCount: exists(json, 'child_collection_count')
      ? json.child_collection_count
      : 0,
    traderCode: exists(json, 'trader_code')
      ? TraderFromJSON(json.trader_code)
      : defaultTrader(),
    acceptType: exists(json, 'accept_type')
      ? SystemCodeFromJSON(json.accept_type)
      : defaultSystemCode(),
    orderPrice: exists(json, 'order_price') ? json.order_price : 0
  }
}

export const defaultBibliographyRealDetailCollection = (): BibliographyRealDetailCollection => ({
  id: 0,
  collectionNo: '',
  holdingBranchCode: defaultSystemCode(),
  callNo: '',
  shelfType: defaultSystemCode(),
  collectionType: defaultSystemCode(),
  status: defaultSystemCode(),
  handlingType: defaultSystemCode(),
  appendixCode: defaultSystemCode(),
  dueDate: '',
  processedDate: '',
  processedBranchCode: defaultSystemCode(),
  forwardingBranchCode: defaultSystemCode(),
  userId: '',
  workMemo: '',
  displayMemo: '',
  localMemo: '',
  appendixLendFlag: false,
  revision: 1,
  childCollectionCount: 0,
  traderCode: defaultTrader(),
  acceptType: defaultSystemCode(),
  orderPrice: 0
})
